import { render, staticRenderFns } from "./_accounting.vue?vue&type=template&id=49ea966e&scoped=true&"
import script from "./_accounting.vue?vue&type=script&lang=js&"
export * from "./_accounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ea966e",
  null
  
)

export default component.exports